module.exports = "/images/pen.svg?637689f1f0cfadb6568c4eb2db108128";